import parkpassAxiosInstance from "../parkpassAxiosConfig";

/**
 * Get all subscription requests (admin)
 * @param {Object} params - Query parameters
 * @param {string} params.status - Optional status filter
 * @param {boolean} params.include_files - Optional, default false
 * @returns {Promise} Array of subscription requests
 */
export const getSubscriptionRequests = async (params = {}) => {
  const queryParams = new URLSearchParams();
  
  if (params.status) {
    queryParams.append("status", params.status);
  }
  
  // Default to false for list view
  queryParams.append("include_files", params.include_files || false);
  
  const queryString = queryParams.toString();
  const url = `/v1/subscription-requests/admin${queryString ? `?${queryString}` : ""}`;
  
  const response = await parkpassAxiosInstance.get(url);
  return response.data;
};

/**
 * Get single subscription request by ID (admin)
 * @param {number|string} requestId - Request ID
 * @param {boolean} includeFiles - Optional, default false
 * @returns {Promise} Subscription request details
 */
export const getSubscriptionRequestById = async (requestId, includeFiles = false) => {
  const response = await parkpassAxiosInstance.get(
    `/v1/subscription-requests/admin/${requestId}?include_files=${includeFiles}`
  );
  return response.data;
};

/**
 * Update subscription request status (admin)
 * @param {number|string} requestId - Request ID
 * @param {string} status - New status
 * @returns {Promise} Updated subscription request
 */
export const updateSubscriptionRequestStatus = async (requestId, status) => {
  const response = await parkpassAxiosInstance.patch(
    `/v1/subscription-requests/admin/${requestId}/status`,
    { status },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.data;
};

/**
 * Download attachment from subscription request (admin)
 * @param {number|string} requestId - Request ID
 * @param {number|string} attachmentId - Attachment ID
 * @returns {Promise} Blob with attachment data
 */
export const downloadSubscriptionRequestAttachment = async (requestId, attachmentId) => {
  const response = await parkpassAxiosInstance.get(
    `/v1/subscription-requests/admin/${requestId}/attachments/${attachmentId}`,
    {
      responseType: "blob",
    }
  );
  
  // Extract filename from Content-Disposition header
  const contentDisposition = response.headers["content-disposition"];
  let filename = `attachment_${attachmentId}`;
  
  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
    if (filenameMatch && filenameMatch[1]) {
      filename = filenameMatch[1].replace(/"/g, "");
    }
  }
  
  return {
    blob: response.data,
    filename: filename,
    contentType: response.headers["content-type"],
  };
};

/**
 * Helper function to trigger browser download
 * @param {Blob} blob - File blob
 * @param {string} filename - Filename
 */
export const triggerDownload = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
